(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const enabledValue = '1';
  const interactiveSelector = 'a, button, input, textarea, select, summary, label, [role="button"]';
  const mediaSelector = [
    'slideshow-slide:not([aria-hidden="true"]) .slide__image',
    'slideshow-slide:not([aria-hidden="true"]) .slide__video',
    'slideshow-slide:not([aria-hidden="true"]) img',
    'slideshow-slide:not([aria-hidden="true"]) video',
    '.hero__media img',
    '.hero__media video',
    '.hero__media-container img',
    '.hero__media-container video',
    '.slideshow__media img',
    '.slideshow__media video',
    '.slideshow-slide img',
    '.slideshow-slide video',
    '.section-background img',
    '.section-background video',
    'img',
    'video',
  ].join(',');

  function isEnabled(element) {
    return getComputedStyle(element).getPropertyValue('--furriko-tap-zoom').trim() === enabledValue;
  }

  function getSection(element) {
    return element.closest('.shopify-section');
  }

  function hasEnabledAncestor(element) {
    let node = element;

    while (node && node !== document.body) {
      if (isEnabled(node)) return true;
      if (node.classList && node.classList.contains('shopify-section')) break;
      node = node.parentElement;
    }

    return false;
  }

  function isFirstHomepageSlideshow(section) {
    const main = document.querySelector('main');
    const firstSection = main && main.querySelector('.shopify-section');
    const hasSlideshow = section.querySelector(
      'slideshow-component, slideshow-slides, slideshow-slide, .slideshow-section, .slide__image-container'
    );

    return section === firstSection && Boolean(hasSlideshow);
  }

  function isVisible(element) {
    return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }

  function getZoomMedia(section, eventTarget) {
    if (!section) return [];

    const sectionEnabled = isEnabled(section) || hasEnabledAncestor(eventTarget) || isFirstHomepageSlideshow(section);
    const media = Array.from(section.querySelectorAll(mediaSelector));

    return media.filter((item) => {
      const enabled = sectionEnabled || isEnabled(item);

      return enabled && isVisible(item);
    });
  }

  function prepareMedia(media) {
    media.forEach((item) => item.classList.add('furriko-mobile-tap-zoom-media'));
  }

  function closeOtherMedia(activeSection) {
    document.querySelectorAll('.furriko-mobile-tap-zoom-media.is-furriko-zoomed').forEach((item) => {
      if (activeSection.contains(item)) return;
      item.classList.remove('is-furriko-zoomed');
    });
  }

  function toggleSection(section, eventTarget) {
    const media = getZoomMedia(section, eventTarget);
    if (!media.length) return;

    prepareMedia(media);
    section.classList.add('furriko-mobile-tap-zoom-root');

    const shouldZoom = !media.some((item) => item.classList.contains('is-furriko-zoomed'));
    closeOtherMedia(section);
    media.forEach((item) => item.classList.toggle('is-furriko-zoomed', shouldZoom));
  }

  document.addEventListener(window.PointerEvent ? 'pointerup' : 'click', (event) => {
    if (!mobileQuery.matches) return;
    if (event.target.closest(interactiveSelector)) return;

    const section = getSection(event.target);
    if (!section) return;

    toggleSection(section, event.target);
  }, true);
})();
